import React from 'react';
import TreeList from './project-tree-list';

class TreeView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      selected: null
    }

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(item){
    this.setState({selected: item});
  }

  render(){
    const { data, components, componentMatches } = this.props;
    const { selected } = this.state;
    const items = (!data.length && data.children) ? data.children : data || [];

    return (
      <div>
        <TreeList
          items={ items }
          collapsed={ false }
          components={ components } 
          componentMatches={ componentMatches }
          styleOverride={{ paddingLeft: 0 }}
          onSelect={ this.handleSelect }
          selected={ selected }
          selectable={ false }
        />
      </div>
    )
  }
}

export default TreeView;